import Relay from './src/SignalWire';
import Verto from './src/Verto';
import { setAgentName } from '../common/src/messages/blade/Connect';
import CantinaAuth from '../common/src/webrtc/CantinaAuth';
export const VERSION = '1.2.8';
setAgentName("JavaScript SDK/".concat(VERSION));
export { Relay, Verto, CantinaAuth };